module.exports = __webpack_public_path__ + "static/orthon-146e14d4b7be4a67780e9975ddf24ebc.png";